import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

interface UseExpirationTextOptions {
  validUntil: string | Date;
  isExpired?: boolean;
}

export const useExpirationText = ({ validUntil, isExpired = false }: UseExpirationTextOptions) => {
  const { locale } = useRouter();
  const t = useTranslations();

  if (isExpired) {
    return t("Expired");
  }

  const now = new Date();
  const validUntilDate = new Date(validUntil);
  const diffTime = validUntilDate.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return t("Expires today");
  if (diffDays === 1) return t("Expires tomorrow");
  if (diffDays >= 2 && diffDays <= 6) {
    return `${t("Expires on")} ${validUntilDate.toLocaleDateString(
      locale?.split("-")[0] || "en-US",
      { weekday: "long" }
    )}`;
  }
  if (diffDays >= 7) {
    return `${t("Expires on")} ${validUntilDate.toLocaleDateString(
      locale?.split("-")[0] || "en-US",
      { month: "long", day: "numeric" }
    )}`;
  }

  return t("Expired");
};
